import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["startDate", "endDate"],
  _excluded2 = ["startDate", "endDate"];
import React from 'react';
import { DatePickerBase } from './DatePickerBase';
export var DateStartPicker = function DateStartPicker(props) {
  var startDate = props.startDate,
    endDate = props.endDate,
    dateProps = _objectWithoutProperties(props, _excluded);
  var maxEndDate = endDate ? new Date(endDate) : new Date();
  maxEndDate.setDate(maxEndDate.getDate() - 1);
  return /*#__PURE__*/React.createElement(DatePickerBase, _extends({}, dateProps, {
    date: startDate,
    dateRange: endDate,
    maxDate: endDate ? maxEndDate : dateProps.maxDate
  }));
};
export var DateEndPicker = function DateEndPicker(props) {
  var startDate = props.startDate,
    endDate = props.endDate,
    dateProps = _objectWithoutProperties(props, _excluded2);
  var minStartDate = startDate ? new Date(startDate) : new Date();
  minStartDate.setDate(minStartDate.getDate() + 1);
  return /*#__PURE__*/React.createElement(DatePickerBase, _extends({}, dateProps, {
    date: endDate,
    dateRange: startDate,
    minDate: startDate ? minStartDate : dateProps.minDate
  }));
};